module.exports = __webpack_public_path__ + "img/gallery-img-7.9442baf9.jpg";